// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";
import { connect } from "react-redux";

import User from "src/components/user/Photo";
import ChatTimestamp from "src/components/messages/Chat/ChatTimestamp";
import NameOrEmail from "src/containers/user/NameOrEmail";
import ReplyTo from "src/components/messages/ReplyTo";
import MessageText from "src/components/messages/MessageText";
import Icon from "src/icons";
import {
  getCurrentUserId,
  getCurrentRoomId,
  getChatroomAddress,
  getSelectedAction,
  getIsSrwMobile,
} from "src/reducers";
import { selectMessage, showMobileOptions } from "src/actions/chatmenu";

import type { UID, AppState } from "src/types";

import MessageCard from "./MessageCard";
import Forward from "./Forward";
import {
  UserInfo,
  ChatCard,
  ForwardedMessage,
  MenuIcon,
  MessageHeader,
  NotificationNameOrEmail,
} from "./styles";

type Props = {
  message: any,
  currentUser: UID,
  selectedAction: string,
  isSrwMobile: boolean,
  _selectMessage: Function,
  _showMobileOptions: Function,
};

const Message = ({
  message,
  currentUser,
  selectedAction,
  isSrwMobile,
  _selectMessage,
  _showMobileOptions,
}: Props) => {
  const { id, author, timestamp, inReplyTo, origin, deleted, read, delivered } =
    message;

  const isCurrentUser = currentUser === author;

  const selectMode = useCallback(
    (e: any) => {
      if (!selectedAction) {
        _showMobileOptions();
        _selectMessage(id, timestamp, isCurrentUser);
        e.stopPropagation();
      }
    },
    [selectedAction, id, timestamp, isCurrentUser],
  );

  // FIXME: To be updated with the actual logic when the profile-picture
  // grouping is implemented
  const isFirstInGroup = true;

  return (
    <ChatCard
      first={isFirstInGroup}
      showSelect={selectedAction && selectedAction !== "MOBILE"}
    >
      {isFirstInGroup ? (
        <UserInfo>
          <User uid={author} size="sm" />
        </UserInfo>
      ) : null}

      <MessageCard first={isFirstInGroup} isMessage>
        {isFirstInGroup && (
          <MessageHeader>
            {isCurrentUser ? (
              <NotificationNameOrEmail>{i18n.t(k.YOU)}</NotificationNameOrEmail>
            ) : (
              <NameOrEmail uid={author} notificationVariant="key" />
            )}
            <ChatTimestamp
              read={read}
              delivered={delivered}
              timestamp={timestamp}
            />
          </MessageHeader>
        )}

        {origin && <Forward message={message} />}
        {origin ? (
          <ForwardedMessage isCurrentUser={isCurrentUser}>
            <NameOrEmail uid={origin.author} notificationVariant="key" />
            <MessageText message={message} isForwarded />
          </ForwardedMessage>
        ) : (
          <>
            {!deleted && (
              <ReplyTo id={inReplyTo} isCurrentUser={isCurrentUser} />
            )}
            <MessageText message={message} />
          </>
        )}

        {isSrwMobile && (
          <MenuIcon onClick={selectMode}>
            <Icon type="menuDown" />
          </MenuIcon>
        )}
      </MessageCard>
    </ChatCard>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  currentUser: getCurrentUserId(app),
  currentRoomAddress: getChatroomAddress(app, getCurrentRoomId(app)),
  selectedAction: getSelectedAction(app),
  isSrwMobile: getIsSrwMobile(app),
});

export default connect(mapStateToProps, {
  _selectMessage: selectMessage,
  _showMobileOptions: showMobileOptions,
})(Message);
